import {environment} from '@environments/environment';
import {SelectItem} from 'primeng/api';

export const DateFormat = environment.dateFormat;
export const DateTimeFormat = environment.dateTimeFormat;
export const TillTwoDigits_Regex = /\d{1,2}$/;
export const OnlyDigits_Regex = /^\d*$/;
export const Date_Regex = /^\d{2}\/\d{2}\/\d{4}$/;
export const SampleTypes = [{label: 'Venous Blood', value: '1'} as SelectItem];
export const Email_Regex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const AtleastOneLowerCase_Regex = /^(?=.*[a-z])/;
export const AtleastOneUpperCase_Regex = /^(?=.*[A-Z])/;
export const AtleastOneDigit_Regex = /^(?=.*\d)/;
export const AtleastOneSpecialChar_Regex = /^(?=.*[=!@#$%^&+_*-])/;
export const BetweenRangeChars_Regex = /^.{12,128}$/;
export const OneLower_OneUpper_OneDigit_OneSpecial_BetweenRangeChar_Regex =
  '^(?=.*[a-z])(?=.*[A-Z])(?=.*[=!@#$%^&+_*-])(?=.*[0-9]).{12,128}$';
export const MinChars_Regex = /^(?=.{3,})/;
export const MinMaxChars_Regex = /^(?=.{3,500}$)/;
export const OnlyAlphaNumericDiacritics = /^[a-zA-Z0-9\-.&,' \u00C0-\u017F]+$/;
export const OptionAll = {label: 'All', value: null} as SelectItem;
export const letterDiacriticsInput_Regex = /^[a-zA-Z\u00C0-\u017F ]+$/;
export const alphanumericSpecialChars_Regex = /^[a-zA-Z0-9.&,'\- ]+$/;
export const alphanumeric_Regex = /^[a-zA-Z0-9]+$/;
export const maxLengthExceeded_Regex = /^[a-zA-Z- \u00C0-\u017F]+$/;
export const alphanumericWithSpecialCharactersAndDiacritics_Regex = /^[a-zA-Z0-9.&(),'\- \u00C0-\u017F]+$/;
export const internalPages = ['/auth/unauthorized', '/auth/logout', '/auth/callback'];
export const publicPages = [
  '/signup',
  '/auth/reset-password',
  '/auth/forgot-password',
  '/signup/thank-you',
  '/signup/expired-token',
  '/auth/account-confirmation',
  '/auth/unauthorized',
];
export const staticPages = [
  '/static-pages/privacy-policy',
  '/static-pages/legal-notice',
  '/static-pages/terms-and-conditions',
  '/static-pages/cookie-policy',
  '/static-pages/contact',
];
